// extracted by mini-css-extract-plugin
module.exports = {"loading-text":"loading-text__cbWPw","bb-inline-donation-form__loading":"bb-inline-donation-form__loading__HDEGw"};